module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAw0lEQVQYlVXQsUpCARgF4M+L412MGhSnIAocfYB8Eof2hsIhuEmLSG7hUA5G6FO09gBBNLXoVkQZNLhl2NB/6XaW8/NzOOdwSuusscAIp34xQgt7CkgwRYbD+E2wi4eisIxjvGGIFa6wjTnu0cyFcB73Jb4wjugn3GG//GeuhxdcI8UFtvCOx8R/PAdXghf4Rq0oPMAtujjDBtaYYTMXtiOyHxVSfOA1nynBUUwyiJl28Bmx9XCVhMsNTsK9gyWq0Q/8AHHPKvwTvZQWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/moreO.png
// module id = XXnY
// module chunks = 1